/**
 * 判断镜权等业务 API 返回是否表示「用户登录 token」失效。
 * 勿把易宝收银台 token 相关文案误判为登录过期。
 */
export function isAuthTokenExpired(res) {
    if (!res || typeof res !== "object")
        return false;
    const code = Number(res.code);
    if (code === 401 || code === 10001)
        return true;
    const m = `${res.message || ""} ${res.msg || ""}`.toLowerCase();
    if (!m.trim())
        return false;
    if (/\bunauthorized\b/.test(m))
        return true;
    if (/(请先|请重新|需要).{0,8}登录/.test(m))
        return true;
    if (/(登录|login).{0,12}(过期|失效|无效|required|expire)/.test(m))
        return true;
    if (/(user[-_]?token|用户token|凭证).{0,12}(过期|失效|无效|expire|invalid)/.test(m))
        return true;
    if (/token.{0,12}(已过期|过期|失效|无效|expire|invalid)/.test(m))
        return true;
  // 排除易宝会话 token 解析失败等支付侧文案
    if (/易宝|yeepay|收银台|wallet|余额/.test(m))
        return false;
    return false;
}
